// extracted by mini-css-extract-plugin
module.exports = {"container":"extracao_container__CrLi0","display":"extracao_display__1DnLz","inputFiltro":"extracao_inputFiltro__3-OvG","btnCriar":"extracao_btnCriar__1g-CQ"};